import React from 'react'
import { Checkbox, Textarea } from '@base'
import { Input, MultiSelect, Select } from '@baseV2'
import { CATEGORY_SOURCE, GST_PERCENTAGE_VALUES, strings } from '@constants'
import {
	FormWrapper,
	SectionItemWrapper,
	FormElementLabel,
	MBCheckboxContainer,
	MBCheckboxMain,
	FormHeading,
	SectionItemWrapperWithTwoItems,
} from '../styles'
import { capitalizeWord } from '@utils'

const _brands = [{ name: 'WEIGHT' }, { name: 'LENGTH' }, { name: 'PIECES' }, { name: 'SET' }, { name: 'POWER' }, { name: 'NUMBER' }]
const gst_percentage_list = Object.entries(GST_PERCENTAGE_VALUES).map(([key, value]) => ({ key, label: value }))
const categoryType = [
	{ key: 'LONG', label: 'LONG' },
	{ key: 'FLAT', label: 'FLAT' },
	{ key: 'OTHER', label: 'OTHER' },
]

const category_source = Object.entries(CATEGORY_SOURCE).map(([key, value]) => ({ key, label: value }))
const CreateItemForm = React.memo(
	({
		state,
		onCategoryChange,
		handleAttributeChange,
		getCommodity,
		availableBrands,
		handleBrandsChange,
		setSource,
		source,
		sourceFilter,
	}) => {
		const {
			category_name,
			category_id,
			commodity,
			thumbnail_url,
			description,
			hsn_code,
			slug,
			gst,
			igst,
			category_attributes,
			priority,
			preferred_units,
			popular_attributes,
			thickness_first,
			type,
			hsn_description,
			specifications,
			other_names,
			brands,
			top,
		} = state

		let selectedbrands = preferred_units?.length > 0 ? _brands.filter((cls) => preferred_units.includes(cls.name)) : []

		let popularAttributeItems = popular_attributes ? Object.entries(popular_attributes)?.filter((item, i) => item[1] !== null) : []

		const onChange = (key) => (value) => {
			onCategoryChange(key, value)
		}

		const onChangeKey = (key) => (value) => {
			onCategoryChange('popular_attributes', { [key]: value })
		}

		const onhandleAttributeChange = (attribute) => {
			handleAttributeChange(attribute)
		}

		const popularAttributesUi = () => {
			return (
				<>
					{popularAttributeItems.map((item, index) => {
						if (item[0] !== null)
							return (
								<SectionItemWrapper key={index}>
									<Input
										type='text'
										label={capitalizeWord(strings(item[0]))}
										value={popular_attributes[item[0]] === true ? '' : popular_attributes[item[0]]}
										onChange={(value) => onChangeKey(item[0])(value.target.value)}
										placeholder={capitalizeWord(strings(item[0]))}
									/>
								</SectionItemWrapper>
							)
					})}
				</>
			)
		}

		const renderAttributeCheckBoxes = () => (
			<MBCheckboxContainer>
				{Object.keys(category_attributes).map((attribute, index) => (
					<MBCheckboxMain key={`${attribute}-${index}`}>
						<Checkbox
							id={attribute}
							size={1.125}
							checked={category_attributes[attribute]}
							onChange={() => onhandleAttributeChange(attribute)}
						/>
						<FormElementLabel htmlFor={attribute}>{capitalizeWord(strings(attribute))}</FormElementLabel>
					</MBCheckboxMain>
				))}
			</MBCheckboxContainer>
		)

		const selectAllBrands = (val) => {
			val ? handleBrandsChange(availableBrands) : handleBrandsChange([])
		}

		const onhandleBrandsChange = (brand, toBeSelected) => {
			// handleBrandsChange()
			let _brands = brands ?? []
			if (toBeSelected) {
				_brands.push(brand)
			} else {
				_brands = _brands?.filter((item) => item?.brand_id !== brand?.brand_id)
			}
			handleBrandsChange(_brands)
		}

		const renderBrandCheckBoxes = () => (
			<MBCheckboxContainer>
				{availableBrands?.map((brand) => {
					const brandName = brand?.brand_name
					const checked = Boolean(brands?.find((_b) => _b?.brand_name === brandName))
					return (
						<MBCheckboxMain key={brandName}>
							<Checkbox id={brandName} size={1.125} checked={checked} onChange={(e) => onhandleBrandsChange(brand, e.target.checked)} />
							<FormElementLabel htmlFor={brandName}>{brandName}</FormElementLabel>
						</MBCheckboxMain>
					)
				})}
			</MBCheckboxContainer>
		)
		return (
			<FormWrapper>
				<SectionItemWrapper>
					<Input
						type='text'
						label={strings('category_name')}
						value={category_name}
						onChange={(value) => onChange('category_name')(value.target.value)}
						placeholder={strings('msg_no_special_char')}
					/>
					<Input type='text' label={strings('category_id')} disabled={true} value={category_id} onChange={(value) => onChange('category_id')(value.target.value)} />
				</SectionItemWrapper>

				<SectionItemWrapper>
					<Select
						label={strings('type')}
						placeholder={strings('select', 'type')}
						data={categoryType}
						displayKey='label'
						primaryKey='key'
						value={categoryType.find((item) => item.key === type) || {}}
						onChange={(value) => onChange('type')(value.key)}
					/>
					<Select
						label={strings('commodity')}
						placeholder={strings('select', 'commodity')}
						data={getCommodity}
						displayKey='commodity_name'
						primaryKey='commodity_name'
						value={commodity}
						onChange={(value) => onChange('commodity')(value)}
					/>
				</SectionItemWrapper>
				<SectionItemWrapper>
					<Input
						type='text'
						label={strings('hsn_code')}
						placeholder={strings('enter', 'hsn_code')}
						disabled={false}
						value={hsn_code}
						onChange={(value) => onChange('hsn_code')(value.target.value)}
					/>
					<Input
						type='text'
						pattern='^[0-9]*$'
						label={strings('priority')}
						placeholder={strings('select', 'priority')}
						value={priority}
						onChange={(value) => onChange('priority')(value.target.value)}
						error={/^[0-9]*$/.test(priority ?? '') ? null : strings('enter_valid_num')}
					/>
				</SectionItemWrapper>
				<SectionItemWrapper>
					<Input
						type='text'
						label={strings('hsn_description')}
						placeholder={strings('enter', 'hsn_description')}
						value={hsn_description}
						onChange={(value) => onChange('hsn_description')(value.target.value)}
					/>
				</SectionItemWrapper>
				<SectionItemWrapper>
					<Select
						label={strings(['gst', '(', '%', ')'])}
						placeholder={strings(['select', 'gst'])}
						data={gst_percentage_list}
						displayKey='key'
						primaryKey='label'
						value={gst_percentage_list.find((item) => item.label === gst) ?? {}}
						onChange={(value) => onChange('gst')(value.label)}
					/>
					<Select
						label={strings(['igst', '(', '%', ')'])}
						placeholder={strings('select', 'igst')}
						data={gst_percentage_list}
						displayKey='key'
						primaryKey='label'
						value={gst_percentage_list.find((item) => item.label === igst) ?? {}}
						onChange={(value) => onChange('igst')(value.label)}
					/>
				</SectionItemWrapper>
				<SectionItemWrapper>
					<Input type='text' label={strings('slug')} placeholder={strings('enter', 'slug')} value={slug} onChange={(value) => onChange('slug')(value.target.value)} />
						<Select
							label={strings('source')}
							placeholder={strings('select', 'source')}
							data={category_source}
							displayKey='key'
							primaryKey='label'
							value={category_source.find((item) => item.label === source) ?? {}}
							onChange={(val) => setSource(val.key)}
							disabled
						/>
				</SectionItemWrapper>

				<FormHeading>{strings('select', 'attributes')}</FormHeading>
				<SectionItemWrapper>{renderAttributeCheckBoxes()}</SectionItemWrapper>

				<SectionItemWrapper>
					<MultiSelect
						id='preferred_units'
						disabled={false}
						label={'Preferred Units'}
						displayKey={'name'}
						primaryKey={'name'}
						placeholder={['Select Preferred Units']}
						data={_brands}
						value={selectedbrands}
						onChange={onChange('preferred_units')}
						multiple
					/>
				</SectionItemWrapper>

				<SectionItemWrapperWithTwoItems>
					<Checkbox
						id='thickness_first_checkbox'
						size={1.125}
						checked={thickness_first}
						value={thickness_first}
						onChange={onChange('thickness_first')}
					/>
					<FormElementLabel htmlFor='thickness_first_checkbox'>{strings('thicknesss', 'first')}</FormElementLabel>
				</SectionItemWrapperWithTwoItems>
				<SectionItemWrapperWithTwoItems>
					<Checkbox id='is_top_checkbox' size={1.125} checked={top} value={top} onChange={onChange('top')} />
					<FormElementLabel htmlFor='is_top_checkbox'>{strings('is', 'top')}</FormElementLabel>
				</SectionItemWrapperWithTwoItems>

				{popularAttributesUi()}
				<SectionItemWrapper>
					<MultiSelect
						id={'other-names'}
						label={'Other Names'}
						data={[]}
						placeholder={'Enter Other Names'}
						primaryKey={'key'}
						displayKey={'label'}
						value={other_names?.map((item) => ({ key: item, label: item })) || []}
						// required={formState.departments.required}
						onChange={onChange('other_names')}
						createNewOption={true}
					/>
				</SectionItemWrapper>
				<SectionItemWrapper>
					<Textarea label={strings('description')} value={description} onChange={onChange('description')} />
				</SectionItemWrapper>
				{availableBrands?.length !== 0 && (
					<>
						<FormHeading isAttribute>
							{strings('select', 'brands')}
							<div>
								<Checkbox
									id={'select-all'}
									size={1.125}
									checked={brands?.length === availableBrands?.length}
									onChange={(e) => selectAllBrands(e.target.checked)}
								/>
								<FormElementLabel htmlFor={'select-all'}>{strings(['select', 'all', 'brands'])}</FormElementLabel>
							</div>
						</FormHeading>
						<SectionItemWrapper>{renderBrandCheckBoxes()}</SectionItemWrapper>
					</>
				)}
			</FormWrapper>
		)
	}
)
export default CreateItemForm
